'use client'

import { Stack } from "@mui/material";
import dynamic from "next/dynamic";
import Grid from '@mui/material/Grid2';
import { useAppointment } from "@/context/appointment";
import { Advisor, AdvisorMeta } from "@/types/appointment";
import React from "react";
import { useTranslations } from "next-intl";
const AdvisorCard = dynamic(() => import('@/components/pages/consultation/advisor-card'), { ssr: false });
import '@/components/styles/consultation/ChooseAdvisor.css';
import {Rfs__consultation} from "../../../../_refs/Rfs__consultation";

export default function ChooseAdvisor() {
    const { advisors, GetAdvisors, selected_advisor } = useAppointment();

    const t = useTranslations('consultation.advisor_card');

    React.useLayoutEffect(() => {
        const GetData = async () => {
            await GetAdvisors();
        };
        GetData();
    }, []);

    Rfs__consultation.chooseAdviser();

    return <Stack
        useFlexGap
        direction={'column'}
        spacing={3}
        className={'CO_ChooseAdvisor'}
    >
        <h2>{t('title')}</h2>


        <Grid
            container
            spacing={1}
            marginTop={1}
        >


            {
                advisors.map((advisor: Advisor) => <Grid
                    key={advisor.email}
                    container
                    size={{ lg: 6, md: 12, sm: 12, xs: 12 }}
                >
                    <AdvisorCard advisor={advisor} />

                </Grid>
                )
            }

        </Grid>


        <h6>
            {
                selected_advisor?.metas.map((meta: AdvisorMeta) =>
                    meta.key === 'description' && meta.value
                )
            }
        </h6>

    </Stack>
};
